/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Visor object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Visor = {
	open: function (options) { //body, width, height, title
		
		if ($(document).scrollTop() < 106)
			$('body').animate({scrollTop: '106px'}, 200, next);
		else
			next();
		
		function next() {
			
			Header.fixed = true;
			$('#menu').css('position', 'fixed').css('top', 0);
			$('header').hide();
			$('body').css('overflow', 'hidden');
			
			$('body').append('<div id="visor-exterior"></div><div id="visor-box"><div class="gap"></div><div class="box" style="width:' + options.width + 'px;' + (options.height ? 'height:' + options.height + 'px;' : '') + '"><div style="height: 30px;">' + (options.title ? '<div style="margin: 8px 12px;display: inline-flex;font-size: 16px;color: grey;text-align: center;">' + options.title + '</div>' : '') + '<span id="visor-close" class="glyphicons glyphicons-remove-2" aria-hidden="true"></span></div>' + options.body + '</div><div class="gap"></div></div>');
			
			$('#visor-box').fadeIn('fast');
			
			$('#visor-exterior').click(Visor.close);
			$('#visor-box > .gap').click(Visor.close);
			$('#visor-close').click(Visor.close);
		}
		
		
	},
	close: function () {
		
		if (Visor.onClose)
			Visor.onClose();
		$('#visor-exterior').remove();
		$('#visor-box').remove();
		
		$('header').show();
		$('body').css('overflow', '');
		
	}
};